// extracted by mini-css-extract-plugin
module.exports = {"image":"general-settings_image__2JFJN"};